var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loadingProduto && _vm.produto.id)?_c('v-container',[_c('v-row',{attrs:{"dense":""}},[_c('v-col',[_c('px-listagem-estoque',{attrs:{"produto-id":_vm.produto.id}})],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }